module.exports = {
  'Choose the language used throughout AlleFlow. This preference follows your account across devices.': 'Vælg det sprog, der bruges i hele AlleFlow. Indstillingen følger din konto på tværs af enheder.',
  'Could not save language.': 'Sproget kunne ikke gemmes.',
  'Danish': 'Dansk',
  'English': 'Engelsk',
  'Interface language': 'Sprog i brugerfladen',
  'Language': 'Sprog'
};
